import axios from "axios"
const BASE_URL = process.env.REACT_APP_API_URL
class EmailApi {
  addEmailTemplate(data, config) {
    return axios.post(BASE_URL + "/email/addEmailTemplate", data, config)
  }

  updateEmailTemplate(data, config) {
    return axios.put(BASE_URL + "/email/updateEmailTemplate", data, config)
  }
  getALLEmailTemplates(config) {
    return axios.get(BASE_URL + "/email/getEmailTemplates", config)
  }
  getEmailTemplateById(id, config) {
    return axios.get(`${BASE_URL}/email/getEmailTemplate/${id}`, config)
  }
  updateEmailTemplateStatus(data, config) {
    return axios.put(
      `${BASE_URL}/email/updateEmailTemplateStatus`,
      data,
      config,
    )
  }

  generateDeleteTemplateOtp = (templateId, config) => {
    return axios.post(`${BASE_URL}/email/generateDeleteTemplateOtp/${templateId}`, {}, config);
  };
  deleteEmailTemplate = (templateId, payload, config) => {
    return axios.delete(`${BASE_URL}/email/deleteEmailTemplate/${templateId}`, { 
      ...config,
      data: payload 
    });
  };




  //emailsubcription
  getAllEmailSubscriptions(config) {
    return axios.get(BASE_URL + "/admin/emailSubscription/getAllEmailSubscriptions", config)
  }
}

const emailApi = new EmailApi()
export default emailApi
